export const FIRST_ELEMENT_KEY = 0;
export const SECOND_ELEMENT_KEY = 1;
export const FEATURED_MATCHES_BASE_CLASS = 'featured-matches-widget';
export const UPCOMING_MATCHES_LAYOUT = 'UPCOMING_MATCHES_LAYOUT';
export const I18N_KEY_NO_UPCOMING_MATCHES = 'no_events.no_upcoming_matches';
export const I18N_KEY_NO_UPCOMING_MATCHES_48_HOURS = `${I18N_KEY_NO_UPCOMING_MATCHES}_48_hours`;
export const I18N_KEY_NO_UPCOMING_MATCHES_WEEK = `${I18N_KEY_NO_UPCOMING_MATCHES}_week`;
export const I18N_KEY_NO_UPCOMING_MATCHES_WEEKS = `${I18N_KEY_NO_UPCOMING_MATCHES}_weeks`;
export const I18N_KEY_NO_UPCOMING_MATCHES_YEAR = `${I18N_KEY_NO_UPCOMING_MATCHES}_year`;
export const GTM_SEE_ALL_MATCHES = 'see-all';
